module.exports = __webpack_public_path__ + "static/img/icon3.cc4fa5f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/icon3.png
// module id = 6ZZs
// module chunks = 1